import { classNames } from "@/react/helpers/twMergeWithCN";

interface CoverImageProps {
  className?: string;
  imageClassName?: string;
  imageUrl: string;
}

export const CoverImage = ({
  className,
  imageUrl,
  imageClassName,
}: CoverImageProps) => (
  <div
    className={classNames(
      "grid place-items-center size-full md:w-[768px]",
      className,
    )}
  >
    <img
      alt=""
      className={classNames(
        "rounded-2xl z-0 col-start-1 row-start-1 border-solid object-cover",
        imageClassName,
      )}
      loading="eager"
      src={imageUrl}
      data-testid="paywall-cover-media"
    />
  </div>
);
